<template>
  <div>
    <div class="panel-body">
      <laravel-pagination
          v-if="displayPagination"
          :data="currentRequestData"
          @pagination-change-page="loadAFDMessagesPage"
          style="margin: 0;"
      ></laravel-pagination>
      <div class="pull-right">
        <a-button v-on:click="onProcessAllClick" type="primary" :disabled="!hasSelection">
          <check-icon></check-icon>
          {{ this.selectedAFDMessages.length > 0 ? this.selectedAFDMessages.length + ' verwerken' :
          'Verwerken' }}
        </a-button>
      </div>
    </div>
    <table class="table" v-bind:class="{ loading: loading }">
      <thead>
      <tr>
        <th class="compact half-padding">
          <a-checkbox ref="globalCheckbox" :checked="allSelected" :indeterminate="indeterminate"
                      @change="onSelectAllChanged"></a-checkbox>
        </th>
        <th class="compact">Berichtnummer</th>
        <th class="compact">Polisnummer</th>
        <th class="compact">Maatschappij</th>
        <th class="compact">Branche</th>
        <th>Omschrijving</th>
        <th class="compact">Ontvangen op</th>
        <th class="compact"></th>
      </tr>
      </thead>
      <UnprocessedGroupedAFDMessageRowComponent
          v-for="(afdMessage, index) in afdMessages"
          :key="index"
          :afd-message="afdMessage"
          @onSelectionChanged="onSelectionChanged"
          @onProcessed="onProcessed"
          @onUnmatched="onUnmatched"
      >
      </UnprocessedGroupedAFDMessageRowComponent>
    </table>
    <div class="panel-body" style="padding-top: 0;">
      <laravel-pagination
          v-if="displayPagination"
          :data="currentRequestData"
          @pagination-change-page="loadAFDMessagesPage"
          style="margin: 0;"
      ></laravel-pagination>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "../store";
import afdMessageApi from "~/api/afd_message";
import UnprocessedGroupedAFDMessageRowComponent
  from "~/modules/sivi/components/UnprocessedGroupedAFDMessageRowComponent";
// import store from '../store';

export default {
  name: "UnprocessedOverviewComponent",
  props: {
    processed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      afdMessages: [],
      currentPage: null,
      currentRequestData: {},
      allSelected: false,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      staticSearches: '$_templating/staticSearches',
    }),
    indeterminate() {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.afdMessages.length
          && this.currentSelectionDiff > 0;
    },
    currentSelectionDiff() {
      return this.afdMessages.filter(i => store.state.selectedAFDMessages.findIndex(x => x.id === i.id) < 0).length;
    },
    selectedAFDMessages() {
      return store.state.selectedAFDMessages;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    hasSelection() {
      return this.selectedAFDMessages.length > 0;
    },
    selectedUnlinkableAfdMessages() {
      return this.selectedAFDMessages.filter(email => typeof email.customer !== "undefined" && email.customer !== null)
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableAfdMessages.length > 0;
    },
  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (this.siviMessage === null && this.afdMessageId === null) {
      throw new Error('Either the sivi message or the afd message id must be provided via the props')
    } else if (this.sourceSiviMessage !== null) {
      this.siviMessage = this.sourceSiviMessage
    }
  },
  mounted() {
    this.loadAFDMessagesPage();
  },
  components: {
    UnprocessedGroupedAFDMessageRowComponent
  },
  methods: {
    onTabChange() {

    },
    onUnmatchAllClick() {

    },
    onProcessAllClick() {
      this.$emit('afd-messages-selected', this.selectedAFDMessages);
    },
    loadAFDMessagesPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return;
      }
      this.loading = true;

      afdMessageApi.paginateUnprocessedGroupedByContractNumber(page).then((response) => {
        this.afdMessages = response.data;
        this.allSelected = false;
        this.currentRequestData = response;
        this.loading = false;
        this.currentPage = page;
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om e-mails te laden',
        });
      });
    },
    selectAFDMessage(afdMessage) {
      store.state.selectedAFDMessages.push(afdMessage);

      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    selectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.selectAFDMessage(this.afdMessages[i]);
      }
    },
    deselectAFDMessage(afdMessage) {
      this.allSelected = false;

      store.state.selectedAFDMessages.splice(store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id), 1);
    },
    deselectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.deselectAFDMessage(this.afdMessages[i]);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.afdMessages) {
        let afdMessage = this.afdMessages[i];

        if (this.allSelected === true && store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id) < 0) {
          this.selectAFDMessage(afdMessage);
        } else if (this.allSelected === false) {
          this.deselectAFDMessage(afdMessage);
        }
      }
    },
    onSelectionChanged(afdMessage, selected, shiftKey) {
      if (selected === true) {
        this.selectAFDMessage(afdMessage);
      } else {
        this.deselectAFDMessage(afdMessage);
      }
    },
    onProcessed() {

    },
    onUnmatched() {

    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
